import { render, staticRenderFns } from "./shehuigongzuozhe.vue?vue&type=template&id=5b775faf&scoped=true&"
import script from "./shehuigongzuozhe.vue?vue&type=script&lang=js&"
export * from "./shehuigongzuozhe.vue?vue&type=script&lang=js&"
import style0 from "./shehuigongzuozhe.vue?vue&type=style&index=0&id=5b775faf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b775faf",
  null
  
)

export default component.exports